var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.sort && !_vm.somatory
      ? _c(
          "div",
          {
            style: `display: flex; gap: 0.5rem; ${
              _vm.columnType
                ? "text-align: end; flex-direction: column;"
                : "flex-direction: row;"
            }`
          },
          [
            _c("span", [_vm._v(" " + _vm._s(_vm.columnName) + " ")]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "end" } },
              [
                _c("span", [_vm._v(_vm._s(_vm.columnType || ""))]),
                _vm._v(" "),
                _c("RenderSortColumn", {
                  attrs: {
                    columnName: _vm.columnName,
                    columnKey: _vm.columnKey,
                    currentColumnFiltered: _vm.currentColumnFiltered,
                    sortDirection: _vm.sortDirection
                  },
                  on: {
                    sortListByKey: function($event) {
                      return _vm.sortListByKey(_vm.columnKey)
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.sort && _vm.somatory
      ? _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.columnName) +
                  " " +
                  _vm._s(_vm.columnType === "(QTY)" ? "" : _vm.columnType) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _vm.columnType === "(QTY)"
              ? _c("span", [_vm._v(" " + _vm._s(_vm.dataList.length) + " ")])
              : _c("RenderSomatoryColumnValue", {
                  attrs: { "data-list": _vm.dataList, property: _vm.columnName }
                })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sort && _vm.somatory
      ? _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              "text-align": "end"
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.columnName))]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "end" } },
              [
                _c("span", [_vm._v(_vm._s(_vm.columnType))]),
                _vm._v(" "),
                _c("RenderSortColumn", {
                  attrs: {
                    columnName: _vm.columnName,
                    columnKey: _vm.columnKey,
                    currentColumnFiltered: _vm.currentColumnFiltered,
                    sortDirection: _vm.sortDirection
                  },
                  on: {
                    sortListByKey: function($event) {
                      return _vm.sortListByKey(_vm.columnKey)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("RenderSomatoryColumnValue", {
              attrs: { "data-list": _vm.dataList, property: _vm.columnKey }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.sort && !_vm.somatory
      ? _c("span", [_vm._v(_vm._s(_vm.columnName))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }